import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/adaIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-4d728d38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-card-outline" }
const _hoisted_2 = {
  key: 0,
  class: "account-card-outline__up mt-30"
}
const _hoisted_3 = {
  class: "text-cut",
  align: "right"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-4"
}, null, -1))
const _hoisted_5 = {
  class: "text-cut",
  align: "right"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-4"
}, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "account-card-outline__down mb-30"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullWrapContainer = _resolveComponent("FullWrapContainer")!
  const _component_BlockCardLayoutBoxedItem = _resolveComponent("BlockCardLayoutBoxedItem")!
  const _component_AmountText = _resolveComponent("AmountText")!
  const _component_LabeledItem = _resolveComponent("LabeledItem")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_BlockCardLayout = _resolveComponent("BlockCardLayout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.accountCardDetails.isArrowUp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_BlockCardLayout, null, {
      default: _withCtx(() => [
        _createVNode(_component_BlockCardLayoutBoxedItem, { class: "account-card__content-details" }, {
          content: _withCtx(() => [
            _createVNode(_component_FullWrapContainer, {
              content: _ctx.accountCardDetails?.transactionId,
              title: _ctx.t('hash')
            }, null, 8, ["content", "title"])
          ]),
          _: 1
        }),
        _createVNode(_component_BlockCardLayoutBoxedItem, { class: "mt-10" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              wrap: false,
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, [
                          _createElementVNode("b", null, [
                            _createVNode(_component_Tooltip, null, {
                              title: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("amount")), 1)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _hoisted_4,
                                  _createVNode(_component_AmountText, {
                                    class: "d-inline",
                                    amount: _ctx.accountCardDetails.amount1
                                  }, null, 8, ["amount"])
                                ]),
                                _createVNode(_component_LabeledItem, { justify: "end" }, {
                                  "inline-label": _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t("amount")), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_AmountText, {
                                        class: "d-inline",
                                        amount: _ctx.accountCardDetails.percentage1,
                                        minPrecision: 2,
                                        unit: "%"
                                      }, null, 8, ["amount"])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      wrap: false,
                      align: "middle"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, [
                          _createElementVNode("b", null, [
                            _createVNode(_component_Tooltip, null, {
                              title: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("rewards")), 1)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _hoisted_6,
                                  _createVNode(_component_AmountText, {
                                    class: "d-inline",
                                    amount: _ctx.accountCardDetails.amount2,
                                    minPrecision: 6
                                  }, null, 8, ["amount"])
                                ]),
                                _createVNode(_component_LabeledItem, { justify: "end" }, {
                                  "inline-label": _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t("rewards")), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_AmountText, {
                                        class: "d-inline",
                                        amount: _ctx.accountCardDetails.percentage2,
                                        minPrecision: 2,
                                        unit: "%"
                                      }, null, 8, ["amount"])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.accountCardDetails.isArrowUp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}